import { ApolloCache, gql } from '@apollo/client';
import { questFragment } from '../fragments/quest';
import { GetQuestsQuery, GetQuestsQueryVariables, UpdateQuestDateRepeatMutation } from '../generated/graphql';
import { getQuestsQuery } from '../queries/quest';
import { forEachPrimaryQuestsQuery } from './cacheHelpers';

export const updateQuestDateRepeatMutation = gql`
    ${questFragment}

    mutation UpdateQuestDateRepeat($questId: String!, $dueDate: DateTimeISO, $repeat: RepeatCreateInput) {
        updateQuest(data: { id: $questId, dueDate: $dueDate, repeat: $repeat }) {
            ...QuestFields
        }
    }
`;

export function updateQuestDateRepeatCache(cache: ApolloCache<any>, { data }: { data?: UpdateQuestDateRepeatMutation | null }) {
    if (!data?.updateQuest) return;

    const updatedQuest = data.updateQuest;

    forEachPrimaryQuestsQuery(cache, (vars, existingData) => {
        const questExists = existingData.quests.some(q => q.id === updatedQuest.id);

        if (!questExists) {
            // Quest doesn't exist in cache - add it
            cache.writeQuery<GetQuestsQuery, GetQuestsQueryVariables>({
                query: getQuestsQuery,
                variables: vars,
                data: {
                    ...existingData,
                    quests: [...existingData.quests, updatedQuest],
                },
            });
        }
    });
}
